function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import React, { Component } from "react";
import { connect } from "react-redux";
import { KEY_ENTER, KEY_SPACE } from "@config/constants";
var SideBarMenu = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(SideBarMenu, Component);
    var _super = _create_super(SideBarMenu);
    function SideBarMenu(props) {
        _class_call_check(this, SideBarMenu);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            activeTabIndex: 0,
            anchorEl: null
        };
        _this.sideBarMenu = null;
        _this.handleClick = _this.handleClick.bind(_assert_this_initialized(_this));
        _this.handleClose = _this.handleClose.bind(_assert_this_initialized(_this));
        _this.setMenuRef = _this.setMenuRef.bind(_assert_this_initialized(_this));
        _this.handleClickOutside = _this.handleClickOutside.bind(_assert_this_initialized(_this));
        _this.toggleFromKeyboard = _this.toggleFromKeyboard.bind(_assert_this_initialized(_this));
        _this.toggleMenuFromKeyboard = _this.toggleMenuFromKeyboard.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(SideBarMenu, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener("mousedown", this.handleClickOutside);
                if (this.props.initialComponent) {
                    var _this_props = this.props, componentMap = _this_props.componentMap, initialComponent = _this_props.initialComponent, sideMenuTabs = _this_props.sideMenuTabs;
                    var mainComponent = componentMap[initialComponent].mainComponent || initialComponent;
                    var activeMainComponentIndex = sideMenuTabs.findIndex(function(tab) {
                        return tab.componentName === mainComponent;
                    });
                    this.setState({
                        activeTabIndex: activeMainComponentIndex
                    });
                }
                if (this.props.activeTabIndex) {
                    this.setState({
                        activeTabIndex: this.props.activeTabIndex
                    });
                }
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(param) {
                var activeTabIndex = param.activeTabIndex;
                if (activeTabIndex !== this.props.activeTabIndex) {
                    this.setState({
                        activeTabIndex: activeTabIndex
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener("mousedown", this.handleClickOutside);
            }
        },
        {
            /**
     *  Toggles the active menu tab and displays the
     *  tab component
     *  @param  sideMenuTab {Object}
     *  @param index {number}
     */ key: "toggleTab",
            value: function toggleTab(sideMenuTab, index) {
                this.handleClose();
                if (this.state.activeTabIndex !== index) {
                    this.props.toggleComponent(sideMenuTab.componentName, {
                        shouldToggleWithTransition: true,
                        activeTabIndex: index
                    });
                    this.setState({
                        activeTabIndex: index
                    });
                }
            }
        },
        {
            /**
     * Toggles sibe menu tab component on enter/space keydown
     * @param event {Object}
     * @param sideMenuTab {Object}
     * @param index {Number}
     */ key: "toggleFromKeyboard",
            value: function toggleFromKeyboard(event, sideMenuTab, index) {
                var key = event.which;
                if (key === KEY_ENTER || key === KEY_SPACE) {
                    this.toggleTab(sideMenuTab, index);
                }
            }
        },
        {
            /**
     *  Open account menu and close it on MenuItem click
     *  @param {Object} event
     */ key: "handleClick",
            value: function handleClick(event) {
                event.stopPropagation();
                var eventTarget = event.currentTarget;
                this.state.anchorEl ? this.handleClose() : this.setState({
                    anchorEl: eventTarget
                });
            }
        },
        {
            /**
     *  Closes the account menu
     */ key: "handleClose",
            value: function handleClose() {
                this.setState({
                    anchorEl: null
                });
            }
        },
        {
            /**
     * Sets ref on the toggle menu wrapper
     * @param {Object} node
     */ key: "setMenuRef",
            value: function setMenuRef(node) {
                this.toggleMenuRef = node;
            }
        },
        {
            /**
     *  Handles click outside of toggled menu and calls
     *  handleClose method if click is outside the menu
     *  @param {Object} event
     */ key: "handleClickOutside",
            value: function handleClickOutside(event) {
                if (this.toggleMenuRef && !this.toggleMenuRef.contains(event.target)) {
                    this.handleClose();
                }
            }
        },
        {
            /**
     *  Opens the menu on space/enter
     *  param event {Object}
     */ key: "toggleMenuFromKeyboard",
            value: function toggleMenuFromKeyboard(event) {
                var key = event.which;
                if (key === KEY_SPACE || key === KEY_ENTER) {
                    this.handleClick(event);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var anchorEl = this.state.anchorEl;
                var sideMenuTabs = this.props.sideMenuTabs;
                var appVersion = process.env.IS_LIVE_API ? process.env.APP_VERSION : "".concat(process.env.APP_VERSION, ".").concat(process.env.LAST_COMMIT_SHA);
                var sideList = /*#__PURE__*/ _jsx(List, {
                    children: sideMenuTabs.map(function(sideMenuTab, index) {
                        return /*#__PURE__*/ _jsxs(ListItem, {
                            className: "side-menu-tab pointer".concat(_this.state.activeTabIndex === index ? " active" : ""),
                            tabIndex: "0",
                            onClick: function() {
                                return _this.toggleTab(sideMenuTab, index);
                            },
                            button: true,
                            children: [
                                sideMenuTab.iconClassNames && /*#__PURE__*/ _jsx("span", {
                                    className: sideMenuTab.iconClassNames
                                }),
                                sideMenuTab.title && /*#__PURE__*/ _jsx("span", {
                                    className: "tab-title",
                                    children: sideMenuTab.title
                                })
                            ]
                        }, index);
                    })
                });
                return /*#__PURE__*/ _jsxs("div", {
                    className: "menu-wrapper",
                    ref: this.setMenuRef,
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "toggled-menu-wrapper",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "icon icon-menu-2 pointer",
                                    "aria-owns": anchorEl ? "side-toggled-menu" : null,
                                    "aria-haspopup": "true",
                                    tabIndex: "0",
                                    onKeyDown: this.toggleMenuFromKeyboard,
                                    onClick: this.handleClick
                                }),
                                /*#__PURE__*/ _jsxs(Drawer, {
                                    id: "side-toggled-menu",
                                    anchorel: anchorEl,
                                    open: Boolean(anchorEl),
                                    onClose: this.handleClose,
                                    className: "menu-internal",
                                    children: [
                                        sideList,
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "app-version",
                                            children: appVersion
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "sidebar",
                            ref: function(node) {
                                return _this.sideBarMenu = node;
                            },
                            children: [
                                sideMenuTabs.map(function(sideMenuTab, index) {
                                    return /*#__PURE__*/ _jsx("div", {
                                        className: "side-menu-tab pointer".concat(_this.state.activeTabIndex === index ? " active" : ""),
                                        tabIndex: "0",
                                        onKeyDown: function(event) {
                                            return _this.toggleFromKeyboard(event, sideMenuTab, index);
                                        },
                                        onClick: function() {
                                            return _this.toggleTab(sideMenuTab, index);
                                        },
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "tab-content",
                                            children: [
                                                sideMenuTab.iconClassNames && /*#__PURE__*/ _jsx("span", {
                                                    className: sideMenuTab.iconClassNames
                                                }),
                                                sideMenuTab.title && /*#__PURE__*/ _jsx("span", {
                                                    className: "tab-title",
                                                    children: sideMenuTab.title
                                                })
                                            ]
                                        })
                                    }, index);
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "app-version",
                                    children: appVersion
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return SideBarMenu;
}(Component);
var mapStateToProps = function(param) {
    var i18n = param.i18n;
    return {
        i18n: i18n
    };
};
export default connect(mapStateToProps)(SideBarMenu);
